import { render, staticRenderFns } from "./aigInsureBTable.vue?vue&type=template&id=02e3adda&"
import script from "./aigInsureBTable.vue?vue&type=script&lang=js&"
export * from "./aigInsureBTable.vue?vue&type=script&lang=js&"
import style0 from "./aigInsureBTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCombobox,VDataTable,VLayout,VTextField})
